import * as Constants from '@/lib/constants'
import DevicesInfo from '@/lib/devices-info'
import moment from 'moment'
import Geo from '@/lib/geo'
import * as Types from '../mutation-types'

const turf = require('@turf/turf')

const state = {
  realtimeDeviceInfos: {},
  realtimePositions: {},
  realtimeMapCenterPosition: [],
  realtimeActiveDeviceIds: [],
  nowShowingRealtime: false,

  autoTracking: false,

  realtimePolygon: {},
}

const getters = {
  realtimeDeviceInfos: state => state.realtimeDeviceInfos,
  realtimePositions: state => state.realtimePositions,
  realtimeMapCenterPosition: state => state.realtimeMapCenterPosition,
  realtimeActiveDeviceIds: state => state.realtimeActiveDeviceIds,
  nowShowingRealtime: state => state.nowShowingRealtime,

  realtimeAutoTracking: state => state.autoTracking,

  realtimePolygon: state => state.realtimePolygon,
}

const mutations = {
  [Types.INIT_REALTIME_INFOS](state, devicesInfo) {
    state.realtimeLatestInfos = {}
    state.realtimePositions = {}
    state.realtimeMapCenterPosition = []

    state.realtimePolygon = {}

    const devices = devicesInfo.devices
    for (let i = 0; i < devices.length; i++) {
      const device = devices[i]
      const identifier = DevicesInfo.getIdentifier(device.username, device.id)
      state.realtimeDeviceInfos[identifier] = { info: null, date: null, active: false }
      state.realtimePositions[identifier] = []
      state.realtimePolygon[identifier] = []
    }
  },

  [Types.ADD_REALTIME_INFO](state, naviRealtimeInfo) {
    const deviceId = naviRealtimeInfo.getDeviceId()
    const position = naviRealtimeInfo.getPosition()
    const username = naviRealtimeInfo.getUsername()
    const leftWorkWidth = naviRealtimeInfo.getLeftWorkWidth()
    const rightWorkWidth = naviRealtimeInfo.getRightWorkWidth()

    const identifier = DevicesInfo.getIdentifier(username, deviceId)

    // リアルタイムの最新情報を保存
    state.realtimeDeviceInfos[identifier].info = naviRealtimeInfo
    state.realtimeDeviceInfos[identifier].date = moment()
    state.realtimeDeviceInfos[identifier].active = true
    if (!state.realtimeActiveDeviceIds.includes(identifier)) {
      state.realtimeActiveDeviceIds.push(identifier)
    }

    // リアルタイム位置情報の積算
    state.realtimePositions[identifier].push(position)

    // ポリゴンを作成
    const targetPoints = state.realtimePositions[identifier]

    if (targetPoints.length > 2) {
      const previousPoint = targetPoints[targetPoints.length - 2]
      const lastPoint = targetPoints[targetPoints.length - 1]

      let twoAgoPoint = null
      if (state.realtimePolygon[identifier].length > 1) {
        twoAgoPoint = targetPoints[targetPoints.length - 3]
      }
      // ポイントからポリゴンを作成
      const coords = Geo.pointToPolygonCoords(previousPoint, lastPoint, leftWorkWidth, rightWorkWidth, twoAgoPoint)

      state.realtimePolygon[identifier].push(coords)
    }

    // centerの計算
    const deviceKeys = Object.keys(state.realtimeDeviceInfos)
    let pointFeatures = []
    for (let i = 0; i < deviceKeys.length; i++) {
      const key = deviceKeys[i]
      const info = state.realtimeDeviceInfos[key].info
      if (info) {
        let point = info.getPosition()
        pointFeatures.push(turf.point(point))
      }
    }
    state.realtimeMapCenterPosition = turf.center(turf.featureCollection(pointFeatures)).geometry.coordinates
  },

  [Types.REFRESH_REALTIME_INFO_ACTIVITIES](state) {
    const identifiers = Object.keys(state.realtimeDeviceInfos)
    for (let i = 0; i < identifiers.length; i++) {
      const identifier = identifiers[i]
      const info = state.realtimeDeviceInfos[identifier]
      if (info) {
        if (info.date) {
          const timeout = Constants.NOW_ACTIVE_CHECK_INTERVAL_SECONDS
          if (moment().valueOf() - info.date.valueOf() > timeout) {
            info.active = false
            if (state.realtimeActiveDeviceIds.length != 0) {
              state.realtimeActiveDeviceIds = state.realtimeActiveDeviceIds.filter(did => did !== identifier)
            }
          }
        }
      }
    }
  },

  [Types.SET_NOW_SHOWING_REALTIME](state, bool) {
    state.nowShowingRealtime = bool
  },

  [Types.SET_NOW_AUTO_TRACKING](state, bool) {
    state.autoTracking = bool
  },
}
const actions = {
  initRealtimeInfos({ commit }, devices) {
    commit(Types.INIT_REALTIME_INFOS, devices)
  },

  addRealtimeInfo({ commit }, naviRealtimeInfo) {
    commit(Types.ADD_REALTIME_INFO, naviRealtimeInfo)
  },

  refreshRealtimeInfoActivities({ commit }) {
    commit(Types.REFRESH_REALTIME_INFO_ACTIVITIES)
  },

  setNowShowingRealtime({ commit }, bool) {
    commit(Types.SET_NOW_SHOWING_REALTIME, bool)
  },

  setNowAutoTracking({ commit }, bool) {
    commit(Types.SET_NOW_AUTO_TRACKING, bool)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
